<template>
<div>
  <el-row>

    <el-col align="left">
      <edit-pane
      v-if="!hidePanel"
      ref="sra"
      prefix="Contractor: ":title="form.summary"
      table-ref="site-contractors-table"
      :edit-mode="editMode"
      @cancel="onCancel" @save="onSave" @edit="onEdit" />


      <el-form  :model="form" :inline="adding ? true : false" label-position="top">
        <el-row :gutter="16">
          <el-col :span="12">
          <select-contractor v-model="form.contractor_id" :disabled="disabled" />
         </el-col>

         <el-col :span="12">
          <select-contractor-sub-category v-model="form.type" label="Type" :disabled="disabled" />
        </el-col>
       </el-row>


        <el-row :gutter="16">
          <el-col :span="12">
            <text-input v-model="form.summary" label="Summary" :disabled="disabled" />
         </el-col>

         <el-col :span="12">
           <text-input v-model="form.invoiceNo" label="Inv. No." :disabled="disabled" />
        </el-col>
       </el-row>

        <el-row :gutter="16">
          <el-col :span="12">
            <date-time-input v-if="form.started || !disabled" v-model="form.started" label="Started" :disabled="disabled" />
         </el-col>

         <el-col :span="12">
           <date-time-input v-if="form.ended || !disabled" v-model="form.ended" label="Ended" :disabled="disabled" />
        </el-col>
       </el-row>

       <el-row :gutter="16">
         <el-col :span="6">
             <currency-input v-if="form.amount || !disabled" label="Amount" v-model="form.amount" :disabled="disabled" />
         </el-col>

         <el-col :span="6">
        <check-box v-model="form.isTaxable" label="Taxable?" :disabled="disabled" />
      </el-col>

        <el-col :span="6">
        <el-form-item v-if="form.isTaxable" :label="taxLabel ? taxLabel : 'Tax'">
          <b>{{this.formatNumber(this.taxes, 2)}}</b>
        </el-form-item>
        </el-col>

        <el-col :span="6">
        <el-form-item v-if="form.isTaxable" label="Total">
          <b>{{this.formatNumber(this.totals, 2)}}</b>
        </el-form-item>

      </el-col>
     </el-row>
      </el-form>

    </el-col>
  </el-row>

  <br />

  <files-panel v-if="!adding" title="Contractor Attachments" type="site" :id="form.site_id" process="contractor" :process-id="form.id"  :max-files="3" :disabled="!isManager('finance|management')" />

</div>

</template>


<script>

import Vue from 'vue'
import VueEvents from 'vue-events'

Vue.use(VueEvents)

import {settings} from '@/components/Data'

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'
import PostMixins from '@/mixins/PostMixins'

import SelectContractor from '@/components/atoms/selects/SelectContractor'
import SelectContractorSubCategory from '@/components/atoms/selects/SelectContractorSubCategory'

import FilesPanel from '@/components/atoms/files/FilesPanel'

export default {

  mixins: [DateMixins, NumberMixins, PostMixins],

  name: 'SiteContractorsDetails',

  components: {
    FilesPanel,
    SelectContractor,
    SelectContractorSubCategory
  },

  props: {

    rowData: {
      type: Object,
    },

    siteId: {
      type: Number,
    },

    adding: {
      type: Boolean,
      default: false
    },

    editMode: {
      type: Boolean,
      default: false
    },

    hidePanel: {
      type: Boolean,
      default: false
    },

    tableRef: {
      type: String,
      default: 'site-contractors-table'
    }

  },



  methods: {

    success (data) {
      this.contractors.push(data)
      this.disabled = true

      this.$events.fire(this.tableRef + '-refresh-table')
      this.$emit('update', this.contractors)
    },

    onCancel () {
      this.disabled = true
    },

    onEdit () {
      this.disabled = false
    },

    onSave () {
      if (!this.form.site_id && this.siteId) {
        this.form.site_id = this.siteId
      }

      this.form.started = this.formatDateTimeSql(this.form.started)
      this.form.ended = this.formatDateTimeSql(this.form.ended)

      this.disabled = true

      this.saveForm(this, '/contractors', (this.adding ? null : this.form.id), this.form,  'Site Contractor', this.success)
    },

    onClose () {
      this.disabled = true
    }

  },



  computed: {

    taxes () {
      this.form.tax = this.taxDue(this.form.amount)
      return this.form.tax
    },

    totals () {
      this.form.total = this.totalDue(this.form.amount, this.form.tax)
      return this.form.total
    }

  },

  data () {
    return {
      disabled: this.adding ? false : true,
      form: this.adding ? this.getTableStruct('site_contractors') : this.rowData,
      taxLabel: settings.taxLabel
    }
  },

  created () {

    if (this.adding) {
      delete this.form.id
      this.form.site_id = this.siteId
    }
  }
}

</script>



// WEBPACK FOOTER //
// SiteContractorsDetails.vue?994b6114